/**
 * ErrorMessage Component
 * 
 * Material Tailwind alert for error display.
 * Task: T054
 * 
 * Props:
 * - message: Error message to display
 * - dismissible: Whether alert can be dismissed (default: false)
 * - onDismiss: Callback when dismissed
 * - correlationId: Optional correlation ID for support
 */

import React from 'react';
import { Alert, Typography } from '@material-tailwind/react';

const ErrorMessage = ({ 
  message, 
  dismissible = false, 
  onDismiss,
  correlationId 
}) => {
  return (
    <Alert
      color="red"
      variant="gradient"
      dismissible={dismissible}
      onClose={onDismiss}
      className="mb-4 bg-fotl-red border-fotl-red"
    >
      <Typography variant="h6" color="white" className="mb-1 font-semibold">
        Error
      </Typography>
      <Typography color="white" className="font-normal">
        {message}
      </Typography>
      {correlationId && (
        <Typography 
          variant="small" 
          color="white" 
          className="mt-2 opacity-90 font-mono text-xs"
        >
          Reference ID: {correlationId}
        </Typography>
      )}
    </Alert>
  );
};

export default ErrorMessage;
